import {
  Box,
  Flex,
} from '@chakra-ui/react';
import AdminNavbarLinks from './AdminNavbarLinks';
import Breadcrumb from './Breadcrumb';

const AdminNavbar = () => {
  const navbarFilter = 'none';
  const navbarBackdrop = 'none';
  const navbarShadow = 'none';
  const navbarBg = 'none';
  const navbarBorder = 'transparent';
  const paddingX = '15px';

  return (
    <Flex
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      borderWidth="1.5px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ xl: 'center' }}
      borderRadius="16px"
      display="flex"
      minH="75px"
      justifyContent={{ xl: 'center' }}
      lineHeight="25.6px"
      pb="8px"
      left={document.documentElement.dir === 'rtl' ? '30px' : ''}
      right={document.documentElement.dir === 'rtl' ? '' : '30px'}
      px={{
        sm: paddingX,
        md: '30px',
      }}
      pt="8px"
      top="18px"
    >
      <Flex
        w="100%"
        flexDirection={{
          sm: 'column',
          md: 'row',
        }}
        alignItems={{ xl: 'center' }}
      >
        <Breadcrumb />
        <Box ms="auto" w={{ sm: '100%', md: 'unset' }}>
          <AdminNavbarLinks />
        </Box>
      </Flex>
    </Flex>
  );
};

export default AdminNavbar;
